import { configureStore } from "@reduxjs/toolkit";
import companyReducer from "./companyReducer";
import cartReducer from "./shoppingCartReducer";
import userReducer from "./userReducer";
import chainReducer from "./chainReducer";
import translationsReducer  from "./translationsReducer";
import toastReducer from "./toastReducer";

export default configureStore({
    reducer:
    {
        cart: cartReducer,
        company: companyReducer,
        user: userReducer,
        chain: chainReducer,
        translations: translationsReducer,
        toast: toastReducer,
    },
});